/** Level-of-detail thresholds shared by the simulation and physics.
 *
 *  X4-style "active zone": bodies within ACTIVE_RADIUS_M of the player ship are
 *  simulated in full (per-module collision, the lazy SDF collider, thermal).
 *  Everything beyond it is demoted to a gravity-only point body — it still
 *  integrates its orbit each tick (see integrateFarBodies in tick.ts) but skips
 *  collision entirely until it re-enters the zone, where it instantly rebuilds
 *  full physics from its untouched module data. Nothing is ever discarded, so a
 *  body returns exactly as it was left. */
export const ACTIVE_RADIUS_M = 2000;

const ACTIVE_RADIUS2 = ACTIVE_RADIUS_M * ACTIVE_RADIUS_M;

/** True when (x, y) lies outside the active zone centred on (fx, fy). */
export function isFar(x: number, y: number, fx: number, fy: number): boolean {
  const dx = x - fx;
  const dy = y - fy;
  return dx * dx + dy * dy > ACTIVE_RADIUS2;
}
